import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const me = async (token) => {
  apiClient.setAuthToken(token);
  const response = await apiClient.request('GET', '/admin/user/me');
  if (!isApiResponseError(response)) {
    return {
      ...response.data,
      ...validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const changeProfile = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const changePassword = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me/change-password', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const changeMail = async (data) => {
  const response = await apiClient.request('PUT', '/admin/user/me/change-email', data);
  if (!isApiResponseError(response)) {
    return validateMessageResponse(response.data?.message, 'string', MESSAGE_COMMON.SUCCESS);
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};
